import React, { useEffect, useState } from 'react';
import { Layout, Row, Col } from 'antd';
import { useLocation } from 'react-router-dom';
import InputAdornment from '@material-ui/core/InputAdornment';
import FileCopyIcon from '@material-ui/icons/FileCopy';
import { useDispatch, useSelector } from 'react-redux';
import InnerHeader from '../../component/InnerHeader';
import InfoMenu from '../../component/InfoMenu';
import ContentDetailBody from '../ContentDetail/ContentDetailBody';
import CButton from '../../component/Button';
import { COutlinedInput, CInput } from '../../component/Input';
import { setContentDraft } from '../../actions/ContentAction';
import Loader from '../../component/Loader/Loader';
import { createContent } from '../../services/napi';

const ContentDetail = () => {
  const dispatch = useDispatch();
  const location = useLocation();
  const { customType } = location.state;

  const [isSaveEnabled, setSaveEnabled] = useState(true);

  const emptyContentFromCustomType = (customType) => {
    const draft = {
      api_id: customType.api_id,
      customType,
      custom_type: customType._id,
      data: { en: {}, ka: {}, ru: {} },
      name: '',
      project: customType.project
    };

    Object.keys(customType.template).forEach((key) => {
      draft.data.en[key] = '';
      draft.data.ka[key] = '';
      draft.data.ru[key] = '';
    });

    return draft;
  };

  useEffect(() => {
    async function setDraft() {
      dispatch(setContentDraft(emptyContentFromCustomType(customType, customType.template)));
    }

    setDraft();
  }, [customType, dispatch]);

  const contentDraft = useSelector(({ content }) => content.contentDraft);

  if (!contentDraft || !Object.keys(contentDraft).length) {
    return <Loader />;
  }

  const setDraft = (content) => {
    dispatch(setContentDraft(content));
  };

  const onSave = async () => {
    setSaveEnabled(false);
    await createContent(contentDraft, contentDraft.project);
    setSaveEnabled(true);
    onBack();
  };

  const actions = [
    { onClick: () => window.history.back(), title: 'Cancel' },
    { disabled: !isSaveEnabled, onClick: onSave, title: 'Save', type: 'primary' }
  ];

  const sections = [
    {
      child: () => (
        <CButton block onClick={() => {}} size="large" type="primary">
          Publish
        </CButton>
      ),
      subtitle: 'The content type has used 0 out of 50 fields.',
      title: 'Fields'
    },
    {
      child: () => {},
      subtitle:
        'Change the entry editor’s appearance for this content type in the Entry editor settings',
      title: 'Entry editor appearrance'
    },
    {
      child: () => (
        <COutlinedInput
          disabled
          endAdornment={
            <InputAdornment position="end">
              <FileCopyIcon />
            </InputAdornment>
          }
          id="outlined-flexible"
          onChange={(event) => {
            setDraft({ ...contentDraft, name: event.target.value });
          }}
          value={customType.name}
          variant="outlined"
          xstyle={{ width: '100%' }}
        />
      ),
      subtitle: 'Use this ID to retrieve everything related to this content type via the API.',
      title: 'Content type ID'
    },
    {
      child: () => {},
      subtitle:
        'Read more about content types in our guide to content modelling. \n\nTo learn more about the various ways of disabling and deleting fields have a look at the field lifecycle.',
      title: 'Documentation'
    }
  ];

  const onBack = () => {
    window.history.back();
  };

  return (
    <Layout>
      <InnerHeader actions={actions} onBack={onBack} title="New Content" />

      <Layout
        style={{
          height: 'calc(100vh - 235px)',
          overflowY: 'scroll',
          paddingLeft: '24px',
          paddingTop: '24px'
        }}
      >
        <Row>
          <Col
            span={18}
            style={{
              paddingRight: '24px'
            }}
          >
            <CInput
              id="outlined-flexible"
              label="Content Name"
              onChange={(event) => {
                setDraft({ ...contentDraft, name: event.target.value });
              }}
              value={contentDraft.name}
              variant="outlined"
              xstyle={{ width: '100%' }}
            />
            <ContentDetailBody contentDraft={contentDraft} setContentDraft={setDraft} />
          </Col>
          <Col span={6}>
            <InfoMenu sections={sections} />
          </Col>
        </Row>
      </Layout>
    </Layout>
  );
};

export default ContentDetail;
